import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Utils } from "arv-reactcomponents";
import TopBar from "./TopBar";
import MainBar from "./MainBar";
import Search from "../../Search";

@inject(
  "HeaderStore",
  "SearchBarStore",
  "CommonStore",
  "NavListStore",
  "ProductStore",
)
@observer
class MobileHeader extends Component {
  constructor() {
    super();
    this.setBrand = this.setBrand.bind(this);
  }

  componentDidMount() {
    if (
      this.props.NavListStore &&
      Object.keys(this.props.NavListStore.navListData).length <= 0
    ) {
      this.props.NavListStore.getNavListData().then(() => {
        console.log("API called from client...NavList");
      });
    }
    Utils.onElementScroll(window, ({ scrollTop, direction }) => {
      this.handleFixedStateHeaderMainbar(scrollTop, direction);
    });
    this.setBrand(this.props.NavListStore);
  }

  get isFixedClassName() {
    const { isFixed, isFixedHeaderHidden } = this.props.HeaderStore;

    if (isFixed && isFixedHeaderHidden) {
      return "is-fixed is-header-hidden";
    } else if (isFixed) {
      return "is-fixed";
    }

    return "";
  }

  setBrand(NavListStore) {
    const isBrandJourney =
      NavListStore &&
      NavListStore.navListData &&
      NavListStore.navListData.data &&
      NavListStore.navListData.data.nnnow &&
      NavListStore.navListData.data.nnnow.level1 &&
      NavListStore.navListData.data.nnnow.level1.length > 0;
    this.props.CommonStore.setBrandPageState(isBrandJourney);
    const brandDetails =
      NavListStore &&
      NavListStore.navListData &&
      NavListStore.navListData.data &&
      NavListStore.navListData.data.metaData &&
      NavListStore.navListData.data.metaData.brand;
    this.props.CommonStore.setBrandDetails(brandDetails);
    this.props.ProductStore.setBrandJourneyDetails(brandDetails);
  }

  handleFixedStateHeaderMainbar(scrollTop, direction) {
    if (scrollTop > 100 && direction === "down") {
      this.props.HeaderStore.setFixedState(true);
      this.props.HeaderStore.setFixedHeaderVisibility(true);
    } else if (scrollTop > 100 && direction === "up") {
      this.props.HeaderStore.setFixedState(true);
      this.props.HeaderStore.setFixedHeaderVisibility(false);
    } else if (!scrollTop || scrollTop <= 100) {
      this.props.HeaderStore.setFixedState(false);
      this.props.HeaderStore.setFixedHeaderVisibility(false);
    }
  }

  render() {
    return (
      <header
        className={`nw-mobileheader-wrap is-having-shippingtext ${
          this.isFixedClassName
        }`}
      >
        {!this.props.SearchBarStore.showSearch ? <TopBar /> : null}
        <MainBar />
        <Search currentState={this.isFixedClassName} />
        <div className="nw-mobileheader-mobilefilterbuttons" />
      </header>
    );
  }
}

MobileHeader.wrappedComponent.propTypes = {
  HeaderStore: PropTypes.shape({
    isFixed: PropTypes.bool.isRequired,
    isFixedHeaderHidden: PropTypes.bool.isRequired,
    setFixedState: PropTypes.func.isRequired,
    setFixedHeaderVisibility: PropTypes.func.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    setBrandJourneyDetails: PropTypes.func.isRequired,
  }).isRequired,
  SearchBarStore: PropTypes.shape({
    showSearch: PropTypes.bool,
  }).isRequired,
  NavListStore: PropTypes.shape({
    getNavListData: PropTypes.func,
    navListData: PropTypes.shape({
      data: PropTypes.shape().isRequired,
    }).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    setBrandPageState: PropTypes.func.isRequired,
    setBrandDetails: PropTypes.func.isRequired,
  }).isRequired,
};

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/component/Header/MobileHeader/index.js